export default __webpack_public_path__ + "static/media/loader.494f85f6.gif";